import { useOrientation } from '@/hooks/useOrientation';
import { useConfigStore } from '@/stores/configStore';
import styles from './styles.module.scss';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { TrackingService } from '@/services/analytics/TrackingService';
import { PATHS } from '@/router/paths';
import { useAccessibilityTTS, useKioskNavigation } from '@/hooks';
import { useHomeStore } from '@/stores';
import { useNavigate } from 'react-router-dom';

export function HomeDetailOverlay() {
    const { t } = useTranslation();
    const { isHorizontal } = useOrientation();
    const { triggerFocusContent } = useKioskNavigation();
    const { stopSpeaking } = useAccessibilityTTS();
    const setHomeMenuVisible = useHomeStore((s) => s.setHomeMenuVisible);
    const navigate = useNavigate();

    const building = useConfigStore((state) => state.config.server?.building);
    const language = useConfigStore((s) => s.config?.ui?.language);

    const screensaverGuideEnabled = building?.screensaverGuideEnabled?.[language];

    const description = building?.screensaverGuideDescription?.[language] || '';

    const handleNavigateToFloorGuide = () => {
        stopSpeaking();
        TrackingService.trackMenuByRoute(PATHS.FLOOR_GUIDE.INDEX);
        navigate(PATHS.FLOOR_GUIDE.INDEX);
        triggerFocusContent();
        setHomeMenuVisible(false);
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleNavigateToFloorGuide();
        }
    };

    if (!screensaverGuideEnabled) return <></>;

    return (
        <div
            className={clsx('absolute left-1/2 z-10 -translate-x-1/2', styles['home-detail'], {
                [styles['home-detail--vertical']]: !isHorizontal,
            })}
        >
            <div
                className="focus-border h-full w-full"
                tabIndex={0}
                data-region-nav
                data-region-order={1}
                data-home-detail-focus
                data-interactive
                aria-label={`${description} ${t('home.detail.desc')}`}
                onKeyDown={handleKeyDown}
                onClick={handleNavigateToFloorGuide}
            >
                <div className={styles['home-detail__desc']}>{description}</div>
            </div>
        </div>
    );
}
